"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _columns = require("../../../../utils/columns");

var _SortArrow = _interopRequireDefault(require("../../../SortArrow"));

var _analysis = require("../../../../context/analysis");

const StyledHeading = (0, _styledComponents.default)(_blocks.DataGridHeading)`
  white-space: nowrap;
`;

const SiteGroupHeader = ({
  activeSort,
  hitCount,
  equipCount,
  groupCount,
  sortDirection,
  onSort
}) => {
  const {
    viewMode
  } = (0, _analysis.useState)();
  const cols = _columns.analysisColumns[viewMode];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.LATEST.minWidth,
    onClick: () => onSort(cols.LATEST.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.LATEST.label(_core.i18n), activeSort === cols.LATEST.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.PRIORITY.minWidth,
    onClick: () => onSort(cols.PRIORITY.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.PRIORITY.label(_core.i18n), activeSort === cols.PRIORITY.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.SEVERITY.minWidth,
    onClick: () => onSort(cols.SEVERITY.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.SEVERITY.label(_core.i18n), activeSort === cols.SEVERITY.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.RULE_NAME.minWidth,
    onClick: () => onSort(cols.RULE_NAME.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.RULE_NAME.label(_core.i18n), " ", /*#__PURE__*/_react.default.createElement(_blocks.Badge, null, groupCount), activeSort === cols.RULE_NAME.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.RULE_TYPE.minWidth,
    onClick: () => onSort(cols.RULE_TYPE.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.RULE_TYPE.label(_core.i18n), activeSort === cols.RULE_TYPE.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.AFFECTED_EQUIPS.minWidth,
    onClick: () => onSort(cols.AFFECTED_EQUIPS.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.AFFECTED_EQUIPS.label(_core.i18n), " ", /*#__PURE__*/_react.default.createElement(_blocks.Badge, null, equipCount), activeSort === cols.AFFECTED_EQUIPS.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))), /*#__PURE__*/_react.default.createElement(StyledHeading, {
    minWidth: cols.TRIGGERED_RULES.minWidth,
    onClick: () => onSort(cols.TRIGGERED_RULES.key)
  }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, cols.TRIGGERED_RULES.label(_core.i18n), " ", /*#__PURE__*/_react.default.createElement(_blocks.Badge, null, hitCount), activeSort === cols.TRIGGERED_RULES.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
    direction: sortDirection
  }))));
};

var _default = SiteGroupHeader;
exports.default = _default;
module.exports = exports.default;